import script from "./OperationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationPage.vue?vue&type=script&setup=true&lang=js"

import "./OperationPage.vue?vue&type=style&index=0&id=0abd3948&lang=scss&scoped=true"

import exportComponent from "/Users/zhangyi/WebstormProjects/aigc-poc-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0abd3948"]])

export default __exports__